import React from 'react'

const Customers = () => {
  return (
    <div>
        
    </div>
  )
}

export default Customers